



































































































































import {Component} from 'vue-property-decorator';
import Report from '@/pdf/Report';
import ReportBackground from '@/pdf/components/ReportBackground.vue';
import Compass from '@/components/Compass.vue';
import SummaryOverview from '@/pdf/components/SummaryOverview.vue';
import PageFooter from '@/pdf/components/PageFooter.vue';

@Component({
  components: {
    ReportBackground,
    Compass,
    SummaryOverview,
    PageFooter,
  },
})
export default class KnowYourCustomer extends Report {
  async mounted() {
    await this.loadQuick('kyc');
  }

  get board() {
    if (!this.doc.overview) {
      return [];
    }
    return this.doc.overview.DIRECTORS
        .filter((x: any) => ['Ordförande', 'Ledamot', 'Suppleant'].indexOf(x.Function) !== -1);
  }

  get management() {
    if (!this.doc.overview) {
      return [];
    }
    return this.doc.overview.DIRECTORS
        .filter((x: any) => ['Verkställande Direktör', 'Extern Verkställande Direktör', 'Vice Verkställande Direktör', 'Extern Firmatecknare'].indexOf(x.Function) !== -1);
  }
}
